import React, { useRef } from 'react';
import Carousel from 'react-multi-carousel';
import { IProduct } from '../../models';
import Image from 'next/image';
import ProductResume from '../Profile/Orders/ProductResume';

const CustomDot = ({
  items,
  active,
  index
}: {
  items: string[];
  active?: boolean;
  index?: number;
}) => {
  return (
    <div
      className={`w-full ${active ? 'bg-primary rounded-md' : 'bg-gray-200'}`}
    >
      {/* {React.Children.toArray(items)[index || 0]} */}
      <div className="h-1 w-full"></div>
    </div>
  );
};
const MycarouselProduct = ({
  gallery,
  video,
  alt
}: {
  gallery: string[];
  video: string;
  alt: string;
}) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 0 },
      items: 1
    }
  };
  const videoRef = useRef<HTMLVideoElement>(null);

  const onVideoClick = () => {
    if (videoRef.current?.paused) {
      videoRef.current.play();
      return;
    }

    videoRef.current?.pause();
  };

  return (
    <div className="flex w-full flex-col lg:flex-row">
      <Carousel
        ssr
        partialVisible
        responsive={responsive}
        swipeable={true}
        draggable={true}
        containerClass="carousel-container w-full"
        infinite={true}
        arrows={false}
        showDots={true}
        customDot={<CustomDot items={gallery} />}
      >
        {gallery.map((item: string) => {
          if (video && item === video) {
            return (
              <video
                key={video}
                ref={videoRef}
                autoPlay
                muted
                loop
                onClick={onVideoClick}
                className="rounded-md"
                playsInline
              >
                <source type="video/mp4" src={item}></source>
              </video>
            );
          }
          return (
            <div className="ml-2 sm:ml-0 min-h-350 sm:min-h-450" key={item}>
              <Image src={item} alt={alt} layout="fill" />
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default MycarouselProduct;
